module.exports = __webpack_public_path__ + "static/media/big-island.adb18db5.bin";